import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-background-50/95 backdrop-blur-md shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 flex-shrink-0">
            <h1 className="font-heading text-2xl md:text-3xl text-foreground-950 whitespace-nowrap cursor-pointer">
              韩漫网
            </h1>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {categories.slice(0, 6).map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="px-3 py-2 text-sm text-foreground-700 hover:text-primary-500 rounded-lg hover:bg-background-100 transition-colors whitespace-nowrap"
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/category/remen"
              className="px-3 py-2 text-sm text-foreground-700 hover:text-primary-500 rounded-lg hover:bg-background-100 transition-colors whitespace-nowrap"
            >
              更多
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <div className="relative">
              {searchOpen ? (
                <div className="flex items-center bg-background-100 rounded-full px-4 py-2">
                  <input
                    type="text"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    placeholder="搜索韩漫..."
                    className="bg-transparent text-sm text-foreground-950 placeholder-foreground-400 outline-none w-40"
                    autoFocus
                    onBlur={() => {
                      if (!searchTerm) setSearchOpen(false);
                    }}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' && searchTerm.trim()) {
                        setSearchOpen(false);
                        setSearchTerm('');
                      }
                    }}
                  />
                  <i className="ri-search-line text-foreground-400 text-sm w-4 h-4 flex items-center justify-center"></i>
                </div>
              ) : (
                <button
                  onClick={() => setSearchOpen(true)}
                  className="w-9 h-9 flex items-center justify-center rounded-full hover:bg-background-100 transition-colors cursor-pointer"
                  aria-label="搜索"
                >
                  <i className="ri-search-line text-foreground-600 text-lg w-5 h-5 flex items-center justify-center"></i>
                </button>
              )}
            </div>
            <Link
              to="/about"
              className="px-4 py-2 text-sm text-foreground-700 hover:text-primary-500 rounded-lg hover:bg-background-100 transition-colors whitespace-nowrap"
            >
              关于我们
            </Link>
          </div>

          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg hover:bg-background-100 transition-colors cursor-pointer"
            aria-label="菜单"
          >
            <i className={`w-5 h-5 flex items-center justify-center ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-foreground-700 text-xl`}></i>
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-4 space-y-2">
            <div className="mb-3">
              <div className="flex items-center bg-background-100 rounded-full px-4 py-2">
                <input
                  type="text"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  placeholder="搜索韩漫..."
                  className="bg-transparent text-sm text-foreground-950 placeholder-foreground-400 outline-none w-full"
                />
                <i className="ri-search-line text-foreground-400 text-sm w-4 h-4 flex items-center justify-center"></i>
              </div>
            </div>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="block px-3 py-2 text-sm text-foreground-700 hover:text-primary-500 hover:bg-background-100 rounded-lg transition-colors"
              >
                {cat.name}
                <span className="ml-2 text-xs text-foreground-400">({cat.count})</span>
              </Link>
            ))}
            <Link
              to="/about"
              className="block px-3 py-2 text-sm text-foreground-700 hover:text-primary-500 hover:bg-background-100 rounded-lg transition-colors border-t border-background-200 pt-3 mt-3"
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}